/* eslint-disable no-undefined */
import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  Input,
  OnDestroy,
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Route } from 'src/app/_models/view/route';
import { RouteService } from 'src/app/services/route.service';
import { ConversionService } from 'src/app/services/conversion.service';
import { combineLatest, Subscription } from 'rxjs';
import { TripService } from 'src/app/services/trip.service';
import * as DaTrip from '../../../_models/daws/trip';
import { ApplicationSettingsService } from 'src/app/services/application-settings.service';
import { switchMap } from 'rxjs/operators';
import { RoutingProfileService } from 'src/app/services/vehicle-routing-profile.service';
import { MAXDBLENGTHS } from 'src/app/utils/maxLengthConstant';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
@Component({
  selector: 'save-route',
  templateUrl: './save-route.component.html',
})
export class SaveRouteComponent implements OnInit, OnDestroy {
  @Input() route: Route;
  routeNameLength: number;
  saveRouteName = '';
  routeSubscription: Subscription;
  errorMessage = '';
  daRouteOptions: DaTrip.RoutingProfile;
  daRouteStops: DaTrip.StopInfo[];
  systemDefaultProfileId = 0;
  defaultProfile: DaTrip.RoutingProfile;
  loading = true;
  @ViewChild('name') name: ElementRef;
  isCheckingRouteName: boolean;
  routeUniqueValidation: string;
  historicalDataVersion: string;

  constructor(
    public saveRouteModalRef: BsModalRef,
    private routeService: RouteService,
    private conversionService: ConversionService,
    private tripService: TripService,
    private applicationSettingsService: ApplicationSettingsService,
    private profileService: RoutingProfileService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.routeNameLength = MAXDBLENGTHS.ROUTE_NAME_LENGTH;
    setTimeout(() => this.name?.nativeElement?.focus());
    this.routeSubscription = combineLatest([
      this.routeService.getMapRoute(this.route.id),
      this.routeService.selectedRoute$,
      this.authenticationService.currentUser,
    ]).subscribe(([mapRoute, selectedRoute, userInfo]) => {
      const isEuRegion = userInfo?.region?.toUpperCase() === 'EU';
      // Todo-yz: the profileId is required and must be greater than zero.
      // What to do with a profile not used route?
      // Save route disabled if profile id is -1, for now.

      const profiles = this.profileService.getProfiles();
      const profileId = this.route.profileId;
      const profile = this.profileService.getProfile(profileId);
      const selectedProfileOptions = profiles.filter(
        (pf) => pf.routingProfileId === profileId
      );
      const selectedProfile = selectedProfileOptions?.length
        ? selectedProfileOptions[0]
        : null;
      mapRoute.options.profileName = selectedProfile?.name;

      //update routeoptions based on selected profile.
      mapRoute.options.vehicleType = this.routeService.getVehicleType(
        selectedProfile?.vehicleType
      );
      mapRoute.options.trkAxles = this.conversionService.getAxels(
        mapRoute?.options?.vehicleType
      );
      mapRoute.options.hazMatType = selectedProfile.vehicleOptions?.hazmatType
        ? selectedProfile.vehicleOptions?.hazmatType
        : 0;

      mapRoute.options.governorSpeedLimit =
        selectedProfile?.vehicleOptions?.governorSpeedLimit;

      if (selectedProfile.routingOptions) {
        mapRoute.options.routeType = selectedProfile?.routingOptions?.routeType;
        mapRoute.options.tollRoads = selectedProfile?.routingOptions?.tollRoads;
        mapRoute.options.ferryDiscourage = selectedProfile?.routingOptions
          ?.ferries
          ? true
          : false;
        mapRoute.options.useTraffic = selectedProfile?.routingOptions
          ?.useTraffic
          ? selectedProfile.routingOptions.useTraffic
          : false;
        mapRoute.options.bordersOpen = selectedProfile?.routingOptions
          ?.useOpenBorders
          ? selectedProfile.routingOptions.useOpenBorders
          : false;
        mapRoute.options.elevLimit =
          selectedProfile?.routingOptions?.elevationLimit;
      }
      //for save we are passing -1 to retain the profileName and update the route
      this.daRouteOptions = this.conversionService.convertToDARouteOptions(
        mapRoute.options.profileName, // passing selected profileName,
        -1,
        mapRoute.options,
        profile,
        isEuRegion ? selectedRoute?.euProfile : undefined
      );

      if (
        this.daRouteOptions?.unitsOfMeasure === 1 &&
        profile?.vehicleOptions?.vehicleConfig
      ) {
        const options = this.conversionService.convertToMetric(
          this.daRouteOptions
        );
        this.daRouteOptions.maxHeight = Number(options?.trkHeight);
        this.daRouteOptions.totalLength = Number(options?.trkLength);
        this.daRouteOptions.maxWidth = Number(options?.trkWidth);
        this.daRouteOptions.totalWeight = Number(options?.trkWeight);
        if (options?.governorSpeedLimit) {
          this.daRouteOptions.governorSpeedLimit = options?.governorSpeedLimit;
        }
        if (options?.elevLimit) {
          this.daRouteOptions.elevationLimit = options?.elevLimit;
        }
      }

      this.daRouteStops = this.conversionService.convertToDALocations(
        this.route.stops
      );

      this.historicalDataVersion = mapRoute?.historicalDataVersion;

      this.loading = false;
    });
    this.applicationSettingsService.store$.subscribe((appSettings) => {
      if (appSettings) {
        this.defaultProfile = appSettings;
        this.systemDefaultProfileId = appSettings.routingProfileId;
      }
    });
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }
  keydownEvent(event) {
    if (event.key === 'Enter' && this.saveRouteName.length > 0) {
      this.checkUniqueAndSaveRoute();
      return false;
    }
  }
  checkUniqueAndSaveRoute() {
    this.isCheckingRouteName = true;
    this.routeUniqueValidation = null;

    this.tripService
      .getUniqueRoute(this.saveRouteName)

      .subscribe((uniqueRoute) => {
        if (uniqueRoute.length) {
          this.isCheckingRouteName = false;
          this.routeUniqueValidation = 'route name must be unique.';
        } else {
          this.isCheckingRouteName = false;
          this.daRouteOptions.dataVersion = this.historicalDataVersion;
          const trip: DaTrip.Trip = {
            Name: this.saveRouteName,
            Profile: this.daRouteOptions,
            Stops: this.daRouteStops,
            Id: null,
            ModifiedOn: null,
          };
          this.saveRoute(trip);
        }
      });
  }
  saveRoute(trip: DaTrip.Trip) {
    this.loading = true;
    delete trip.Id;
    delete trip.ModifiedOn;
    // trip.Profile.name = this.saveRouteName;
    this.tripService
      .createTrip(trip)
      .pipe(
        switchMap((createdTrip) => {
          trip.Id = createdTrip.Id;
          //get call based on createdTripId
          return this.tripService.getTripByTripId(createdTrip.Id);
        })
      )
      .subscribe(
        (result) => {
          const profileIdForTheCreatedTrip = result?.length
            ? result[0].Profile?.routingProfileId
            : this.systemDefaultProfileId;
          this.saveRouteModalRef.hide();
          this.routeService.updateRouteAfterSave(
            this.route.id,
            trip.Id,
            this.saveRouteName,
            profileIdForTheCreatedTrip
          );
          this.loading = false;
        },
        (err) => {
          this.errorMessage = 'There was an error saving the route.';
          this.loading = false;
        }
      );
  }
}
